import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { SantosoStatus } from './const'
import { notesAPI } from '../api/notes'
import { Notes } from '../api/notes/types'

interface INotesRedux {
    status: string,
    data: Notes[],
    error: any
}

const initialNotesRedux:INotesRedux = {
    status: SantosoStatus.LOADING,
    data: [],
    error: null,
};

const notesIncomingSlice = createSlice({
    name: 'notesIncoming',
    initialState: initialNotesRedux,
    reducers: {
        getNotes: (state) => {

        }
    },
    extraReducers: (builder) => {
        builder.addCase(fetchAllIncomingNotes.fulfilled, (state, action) => {
            state.data = action.payload
            state.status = SantosoStatus.LOADED
            state.error = null
        })
        builder.addCase(fetchAllIncomingNotes.rejected, (state, action) => {
            state.status = SantosoStatus.ERROR
            state.error = action.error
        })
        builder.addCase(fetchAllIncomingNotes.pending, (state, action) => {
            state.status = SantosoStatus.LOADING
            state.error = null
        })
    }
})

export const fetchAllIncomingNotes = createAsyncThunk(
    'notes/fetchAllIncomingNotes',
    async (userId, thunkAPI) => {
      const response = await notesAPI.getIncomingNotes()
      return response.data
    }
  )

export {notesIncomingSlice}